import { loadModules } from "esri-loader";
import React from "react";
import { TYPE } from "../../types";
import { configContext } from "../config-provider";

interface ArcgisMapProps {
  type: TYPE;
}

export let map: any, view: any, featureLayer: any;

export const listOfType = [
  {"type":2 ,"showLabel":true,"key":"LAMP_NO"},
  {"type":3 ,"showLabel":false,"key":"BOLLARD_NO"},
  {"type":4 ,"showLabel":false,"key":"CONTR_NO"},
  {"type":0 ,"showLabel":false,"key":"CABLE_NO"},
  {"type":5 ,"showLabel":false,"key":"IT_AIDS_NO"},
  {"type":1 ,"showLabel":false,"key":"CONN_NO"},
  {"type":24 ,"showLabel":false,"key":"DRAWPIT_NO"},
];

export const typeToNumber = (type: TYPE) => {
  switch (type) {
    case "lamppost":
    case "lantern":
      return {
        type: 2,
        key: "LAMP_NO",
      };
    case "bollard":
      return {
        type: 3,
        key: "BOLLARD_NO",
      };
    case "controller":
      return {
        type: 4,
        key: "CONTR_NO",
      };
    case "cable":
      return {
        type: 0,
        key: "CABLE_NO",
      };
    case "gsds":
      return {
        type: 5,
        key: "IT_AIDS_NO",
      };
    case "connector":
      return {
        type: 1,
        key: "CONN_NO",
      };
    case "drawpit":
      return {
        type: 24,
        key: "DRAWPIT_NO",
      };
  }
};

const Component: React.FC<ArcgisMapProps> = (props) => {
  const { type } = props;
  const mapRef = React.useRef<HTMLDivElement>(null);

  const { arcgisURL } = React.useContext(configContext);

  React.useEffect(() => {
    loadModules(
      ["esri/Map", "esri/views/MapView", "esri/layers/FeatureLayer"],
      {
        css: true,
      }
    ).then(([ArcGISMap, MapView, FeatureLayer]) => {
      map = new ArcGISMap({
        basemap: "topo-vector",
      });

      const mapping = typeToNumber(type);

      featureLayer = new FeatureLayer(
        {
          url: `${arcgisURL}${mapping.type}`,
          labelingInfo: [
            {
              symbol: {
                type: "text",
                color: "green",
                font: {
                  family: "Playfair Display",
                  size: 12,
                  weight: "bold",
                },
              },
              labelPlacement: "above-center",
              labelExpressionInfo: {
                expression: `$feature.${mapping.key}`,
              },
            },
          ],
        });

      listOfType.forEach(type => {
        const temp = new FeatureLayer(
          {
            url: `${arcgisURL}${type.type}`,
            labelsVisible: type.type === mapping.type,
            minScale: 5000,
            labelingInfo: [
              {
                symbol: {
                  type: "text",
                  color: "green",
                  font: {
                    family: "Playfair Display",
                    size: 12,
                    weight: "bold",
                  },
                },
                labelPlacement: "above-center",
                labelExpressionInfo: {
                  expression: `$feature.${type.key}`,
                },
              },
            ],
          })
        map.add(temp);
      });

      view = new MapView({
        container: mapRef.current,
        map: map,
        center: [114.1, 22.3],
        zoom: 12,
        ui: {
          components: [],
        },
      });

      view.ui.add("arcgis-search", "top-left");

      return () => {
        if (view) {
          view.destroy();
        }
      };
    });
  });

  return <div className="webmap" ref={mapRef} style={{ height: "100%" }} />;
};

export const ArcGisMap = React.memo(Component);